import Router from 'next/router';
import querystring from 'querystring';
import { type ActionsObject, makeAction, makeReducer } from '@finn-no/redux-actions';

import { ApiActionStatus, type HotelResults, type ThunkResult } from '../interfaces';
import defaultState from './defaultState';
import { filtersToApiQueryParams, filtersToBrowserQueryParams } from '../lib/utils/queryParamFilterConversions';
import { fetchOffersForHotel } from '../api/fetcher';

export const actions: ActionsObject<HotelResults> = {};

actions.setPending = makeAction('HOTEL_RESULT_PENDING', (state) => ({
    ...state,
    status: ApiActionStatus.PENDING,
}));

actions.setResults = makeAction('HOTEL_RESULT_OK', (_, action) => ({
    ...defaultState.hotelResults,
    ...action.payload,
    status: ApiActionStatus.OK,
}));

actions.setError = makeAction('HOTEL_RESULT_ERROR', (state) => ({
    ...state,
    status: ApiActionStatus.ERROR,
}));

export const fetchHotelResults =
    // biome-ignore lint/suspicious/noExplicitAny: This was set before biome was added
        (payload?: any): ThunkResult<Promise<void>> =>
        async (dispatch, getState): Promise<void> => {
            dispatch(actions.setPending());
            const queryParams = querystring.stringify(filtersToBrowserQueryParams(getState().filters));
            await Router.replace({ pathname: Router.pathname, query: queryParams }, undefined, { shallow: true });
            const { statusCode, data } = await fetchOffersForHotel(filtersToApiQueryParams({ ...getState().filters, ...payload }));

            switch (statusCode) {
                case 200:
                    dispatch(actions.setResults(data));
                    break;
                default:
                    dispatch(actions.setError());
            }
        };

export const fetchHotelResultsToAppend =
    // biome-ignore lint/suspicious/noExplicitAny: This was set before biome was added
        (payload?: any): ThunkResult<Promise<void>> =>
        async (dispatch, getState): Promise<void> => {
            dispatch(actions.setPending());
            const { statusCode, data } = await fetchOffersForHotel(filtersToApiQueryParams({ ...getState().filters, ...payload }));
            const topOffers = getState().hotelResults.offers;

            switch (statusCode) {
                case 200: {
                    const { offers, ...newHotelResults } = data as HotelResults;
                    // Append the new offers to the previous (top) offers.
                    const appendedOffers = [...topOffers, ...offers];
                    dispatch(actions.setResults({ ...newHotelResults, offers: appendedOffers }));
                    break;
                }
                default:
                    dispatch(actions.setError());
            }
        };

export const hotelResultReducer = makeReducer<HotelResults>(actions);
